import { computed } from 'vue';
import { useRootStore } from '@/stores';
import { STAGE } from '@/consts/stage';
import { useIsStageNavigationEnabled } from '@/composables/useAdminStage';

/**
 * Composable for handling stage switching functionality
 * @returns {Object} Stage switcher data and methods
 */
export function useStageSwitcher() {
    const rootStore = useRootStore();
    const isVisible = useIsStageNavigationEnabled();

    // Compute the stage switcher menu item
    const stageSwitcherMenuItem = computed(() => {
        const selectedStageId = rootStore.selectedStageId;
        let nextStage;

        if (selectedStageId === STAGE.RETENTION.id) {
            nextStage = STAGE.ADMISSIONS;
        } else if (selectedStageId === STAGE.ADMISSIONS.id) {
            nextStage = STAGE.RETENTION;
        }

        return {
            name: `Switch to ${nextStage.name}`,
            onclick: () => rootStore.updateSelectedStageId(nextStage.id),
            showInStaffNav: false
        };
    });

    return {
        stageSwitcherMenuItem,
        canAccessStageSelector: isVisible
    };
}
